var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('components.projects.transferProjects')))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/projectsTransfers/create?project_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.projects.addition'))+" ")])],1),_c('indexTable',{attrs:{"searchText":_vm.$t('components.projects.searchForOperation'),"emptyTableText":_vm.$t('components.projects.thereAreNoOperations'),"emptyTableSubText":_vm.$t('components.projects.tryAddingAfterItemsAndTryAgain'),"filter":{project_id: _vm.$route.params.id},"withoutCard":true,"cloumns":[
        { column: 'code', title: _vm.$t('components.projects.proces'), type: 'mainLink', sort: true },
        {
          column: 'from_project_id',
          title: _vm.$t('components.projects.fromProject'),
          type: 'link',
          to: 'fromProject',
          sort: true,
          link: true,
        },
        {
          column: 'to_project_id',
          title: _vm.$t('components.projects.toAProject'),
          type: 'link',
          to: 'toProject',
          sort: true,
          link: true,
        },
        {
          column: 'date',
          title: _vm.$t('components.projects.operationDate'),
          type: 'text',
          sort: true,
        },
        { column: 'total', title: _vm.$t('components.projects.total'), type: 'text', sort: true },
        {
          column: 'description',
          title: _vm.$t('components.projects.thatAbout'),
          type: 'text',
          sort: true,
        },
        {
          column: 'options',
          title: _vm.$t('components.projects.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role:
                _vm.$user.admin ||
                _vm.$user.role.projects_deposits_edit,
            },
            { name: 'printProjectsDeposit', role: true },
            {
              name: 'delete',
              role:
                _vm.$user.admin ||
                _vm.$user.role.projects_deposits_delete,
            } ],
        } ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem:
          _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading'),
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }